module.exports = __webpack_public_path__ + "static/media/type_b.0bc4918f.png";